import React from 'react';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface IListHeader {
	pageHeader?: string;
	pageIntro?: string;
	externalSource?: ILink;
}

const ListHeader: React.FC<IListHeader> = ({
	pageHeader,
	pageIntro,
	externalSource,
}) => {
	return (
		<div className="distributor-list__header">
			<div className="distributor-list__header-inner">
				<div className="distributor-list__header-left">
					{pageHeader && <h1>{pageHeader}</h1>}
					{pageIntro && <p>{pageIntro}</p>}
				</div>
				<div className="distributor-list__header-right">
					{externalSource?.href?.length > 0 && (
						<Button {...externalSource} className="btn-link" />
					)}
				</div>
			</div>
		</div>
	);
};

export default ListHeader;
